import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Axios client for FreelanZen API.
 *
 * Auth is carried by httpOnly cookies (`access_token` for local JWT and
 * `session_token` for Emergent Google Auth) set by the backend, so we simply
 * enable credentials on every request — no token is ever stored in JS.
 */
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Normalize backend error detail (string | pydantic error array) into a readable string
export function errMsg(err, fallback = "Errore, riprova") {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || String(e)).join(" · ");
  return typeof d === "object" ? (d.msg || JSON.stringify(d)) : String(d);
}

export default api;
